export default __webpack_public_path__ + "static/media/logonobg.3b72a455.png";